
import React, {useState} from 'react';
import {Box, createTheme, ThemeProvider} from "@mui/material";
import Modal from "@mui/material/Modal";
import CircularProgress from '@mui/material/CircularProgress';

const theme = createTheme({
    palette: {
        primary: {
            main: "#0000b7"
        },
        secondary: {
            main: "#AAAAAA"
        },
    },
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4
};

export default function ProgressModal(props) {

    const progressText = props.text ? props.text : "Loading...";
    const [open, setOpen] = useState(props.open ? props.open : false);

    const theme = createTheme({
        palette: {
            primary: {
                main: "#0000b7"
            },
            secondary: {
                main: "#AAAAAA"
            },
        },
    });

    return (
        <React.Fragment>
            <ThemeProvider theme={theme}>
                <Modal
                    open={open}
                >
                    <div className={"setupmodal-color"}>
                        <ThemeProvider theme={theme}>
                            <Box sx={style}>
                                <div style={{textAlign:"center"}}>
                                    <CircularProgress color={"primary"}/>
                                </div>
                                <div style={{textAlign: "center", marginTop: "20px"}}>
                                    {progressText}
                                </div>
                            </Box>
                        </ThemeProvider>
                    </div>
                </Modal>
            </ThemeProvider>
        </React.Fragment>
    )
}